import Vue from 'vue'
import Router from 'vue-router'

import Home from '../components/Home.vue'
import Overview from '../components/Overview.vue'
import Features from '../components/Features.vue'
import Benefits from '../components/Benefits.vue'
import About from '../components/About.vue'
import Contact from '../components/Contact.vue'
import FreeDemo from '../components/FreeDemo.vue'
import Blog from '../components/blogs/Blog.vue'
import Thanks from '../components/Thanks.vue'

Vue.use(Router)
Vue.config.devtools = true

const withPrefix = (prefix, routes) => 
  routes.map( (route) => {
      route.path = prefix + route.path;
      return route;
});

const routes= [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/overview',
      name: 'overview',
      component: Overview
    },
    {
      path: '/features',
      name: 'features',
      component: Features
    },
    {
      path: '/benefits',
      name: 'benefits',
      component: Benefits
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/support',
      name: 'contact',
      component: Contact
    },  
    {
      path: '/free-demo',
      name: 'free-demo',
      component: FreeDemo
    },
    {
      path: '/thanks',
      name: 'thanks',
      component: Thanks
    },
    {
      path: '/blog/:id',
      name: 'blog',
      component: Blog,
      props: true
    },
    {
      path: '*',
      name: 'default',
      component: Home
    }
  ]
  .concat(

    withPrefix('/admin',[
      // { 
      //   path: '/users',
      //   component: Users
      // },
      // {
      //   path: '/settings',
      //   component: Users
      // },
      // {
      //   path: '/locations',
      //   component: Locations
      // }
    ])
  )

export default new Router({
  routes: routes
})



// WEBPACK FOOTER //
// ./src/js/router/index.js